import { useQuery } from '@tanstack/react-query';
import { getUsage } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useUsage = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.subscription.usage(),
        queryFn: getUsage,
        enabled: options?.enabled ?? true,
    });
};
